var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 6,
    viewBox: "0 0 4 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.704042 0C0.523251 0 0.349413 0.0631413 0.210343 0.18311C-0.0608431 0.429361 -0.0608431 0.833465 0.210343 1.07972L2.31725 2.99921L0.20339 4.91871C-0.0677966 5.16496 -0.0677966 5.56906 0.20339 5.81531C0.474576 6.06156 0.9196 6.06156 1.19079 5.81531L3.79835 3.44751C3.93047 3.32755 4 3.16969 4 2.99921C4 2.82873 3.92351 2.67088 3.79835 2.55091L1.19774 0.18311C1.05867 0.0631413 0.877879 0 0.704042 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCollapsed);
export default __webpack_public_path__ + "static/media/ArrowCollapsed.0c90cedef6b5421ea64cd924e48ce2b3.svg";
export { ForwardRef as ReactComponent };